import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

Alpine.data('pageslider', () => ({
    init() {
        const horizontalSection = this.$root;

        gsap.registerPlugin(ScrollTrigger);

        let pinWrap = horizontalSection.querySelector('.page-slider__pin');
        let animWrap = pinWrap.querySelector('.page-slider__slider');
        let animWrapStyles = window.getComputedStyle(animWrap);
        let outerSpace = Math.abs(parseInt(animWrapStyles.marginLeft)) + Math.abs(parseInt(animWrapStyles.marginRight));

        let getToValue = () => -(animWrap.scrollWidth - pinWrap.getBoundingClientRect().width) + outerSpace;
        console.log(animWrap);

        gsap.fromTo(
            animWrap,
            {
                x: () => 0,
            },
            {
                x: () => getToValue(),
                ease: 'none',
                scrollTrigger: {
                    trigger: horizontalSection,
                    start: 'top top',
                    end: () => '+=' + (animWrap.scrollWidth - pinWrap.getBoundingClientRect().width),
                    pin: pinWrap,
                    invalidateOnRefresh: true,
                    anticipatePin: 1,
                    scrub: true,
                },
            }
        );
    },
}));
